module.exports = __webpack_public_path__ + "static/img/sz03.dce8b8cf.png";